/* Frag Rance -- Knopf + Panel, Sektion fd-frag-rance.liquid.
   Kein Framework, Machart wie fd-finder.js: eigenes esc(), Zustand in einem
   Objekt je Sektion, DOM direkt gebaut.

   Der Server ist zustandslos je Aufruf: er kennt den Verlauf nur, wenn das
   Widget ihn mitschickt (siehe beratung() in frag-rance.js). Deshalb haelt
   dieses Skript den ganzen Verlauf im Speicher und schickt ihn bei jeder
   Nachricht komplett mit -- genau wie server/tools/frag-rance-test.mjs es
   fuer die Kommandozeile tut. */
(function () {
  'use strict';

  function esc(s) {
    return (s == null ? '' : String(s)).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  // Fuer url(...) in einem style="..."-Attribut: encodeURIComponent trifft
  // Leerzeichen/Unicode, aber NICHT die CSS-Sonderzeichen ' ( ) -- die
  // wuerden sonst aus der url()-Klammer bzw. dem Attribut ausbrechen.
  function cssUrl(u) {
    return encodeURI(String(u || '')).replace(/['()"]/g, function (c) { return '%' + c.charCodeAt(0).toString(16); });
  }

  // "N°118 After Dark" -> Nummer klein, Name gross (wie fd-finder.js).
  function zerlegeName(titel) {
    var m = String(titel || '').match(/^\s*(N[°o]\s*\d+)\s+(.+)$/i);
    return m ? { nummer: m[1], name: m[2] } : { nummer: '', name: titel || '' };
  }

  // Safari-Privatmodus wirft bei jedem sessionStorage-Zugriff -- ein
  // Testtreffer genuegt, alle Zugriffe gehen deshalb hier durch.
  function speicherLesen(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function speicherSchreiben(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  function speicherLoeschen(k) { try { sessionStorage.removeItem(k); } catch (e) {} }

  function sitzungsId() {
    var k = 'fd-fr-sitzung';
    var v = speicherLesen(k);
    if (!v) { v = (crypto.randomUUID ? crypto.randomUUID() : String(Date.now()) + Math.random()); speicherSchreiben(k, v); }
    return v;
  }

  document.querySelectorAll('[data-fr]').forEach(function (wurzel) {
    var sid = wurzel.id.replace(/^fd-fr-/, '');
    var i18nEl = document.getElementById('fd-fr-i18n-' + sid);
    if (!i18nEl) return;
    var T;
    try { T = JSON.parse(i18nEl.textContent); } catch (e) { return; }

    // Shopifys `t`-Filter maskiert Locale-Texte als HTML (ausser bei
    // _html-Schluesseln). Einmal zurueckdrehen, sonst zeigt textContent die
    // rohe Entity ("&#39;") und esc() wuerde ein zweites Mal maskieren --
    // gleiches Muster wie in fd-finder.js.
    function unesc(s) {
      return String(s).replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>')
        .replace(/&quot;/g, '"').replace(/&#(?:39|x27);/g, "'");
    }
    (function tief(o) {
      if (o && typeof o === 'object') {
        for (var k in o) { if (typeof o[k] === 'string') o[k] = unesc(o[k]); else tief(o[k]); }
      }
    })(T);

    var knopf = wurzel.querySelector('[data-fr-toggle]');
    var panel = wurzel.querySelector('[data-fr-panel]');
    var verlaufEl = wurzel.querySelector('[data-fr-verlauf]');
    var form = wurzel.querySelector('[data-fr-form]');
    var input = wurzel.querySelector('[data-fr-input]');
    var senden = wurzel.querySelector('[data-fr-send]');
    var figurWrap = wurzel.querySelector('[data-fr-figur]');
    var panelFigurWrap = wurzel.querySelector('[data-fr-panel-figur]');
    var schliessen = wurzel.querySelector('[data-fr-close]');

    var VERLAUF_KEY = 'fd-fr-verlauf';
    var sitzung = sitzungsId();
    var verlauf = [];       // { rolle: 'kunde'|'bot', text, produkte?, pose? }
    try { verlauf = JSON.parse(speicherLesen(VERLAUF_KEY) || '[]').slice(-16); } catch (e) { verlauf = []; }
    var offen = false;
    var laeuft = false;     // eine Anfrage unterwegs -- keine zweite gleichzeitig
    var beendet = false;    // Server hat "ende: true" gemeldet (Deckel)
    var geoeffnetSchon = verlauf.length > 0; // Verlauf da -> Begruessung nicht nochmal

    // Echter Crossfade: je Figur zwei deckungsgleiche <img>, die "hintere"
    // (nicht is-aktiv) bekommt die neue Pose und wird erst nach ihrem eigenen
    // onload eingeblendet -- die Figur bleibt dabei DURCHGEHEND sichtbar,
    // kein Aus-/Einblenden mit Luecke dazwischen (Daniel: sah wie Flackern aus).
    // Reduced motion: sofortiger src-Tausch am aktiven Bild, keine Ueberblendung.
    var keinBewegen = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function crossfade(wrap, src) {
      if (!wrap) return;
      var imgs = wrap.querySelectorAll('img');
      var aktiv = wrap.querySelector('img.is-aktiv') || imgs[0];
      if (!aktiv || aktiv.src === src) return;
      if (keinBewegen) { aktiv.src = src; return; }
      var hinten = aktiv === imgs[0] ? imgs[1] : imgs[0];
      hinten.onload = function () { hinten.classList.add('is-aktiv'); aktiv.classList.remove('is-aktiv'); };
      hinten.src = src;
    }
    function pose(name) {
      var src = T.poses && T.poses[name];
      if (!src) return;
      crossfade(figurWrap, src);
      crossfade(panelFigurWrap, src);
    }

    // NUR dieses eine Markdown-Linkmuster wird zu <a> (Duftzwillinge-PDF u.ae.
    // eigene Seiten) -- URL muss auf unsere Domain, eine relative Shop-Seite
    // oder den App-Proxy (/apps/frag-rance/..., seit 25.08.2026 die Duftzwillinge-
    // PDF -- bleibt so auf der Shopdomain statt der Hub-URL) zeigen, sonst
    // bleibt der Text unveraendert (kein beliebiges HTML aus dem Modell).
    var MARKDOWN_LINK = /\[([^\]\[]{1,80})\]\((https:\/\/hub\.seventhscent\.shop\/[^\s()]+|\/(?:pages|products|collections)\/[^\s()]+|\/apps\/frag-rance\/[^\s()]+)\)/g;
    function botHtml(text) {
      var raus = '', letzter = 0, m;
      MARKDOWN_LINK.lastIndex = 0;
      while ((m = MARKDOWN_LINK.exec(text))) {
        raus += esc(text.slice(letzter, m.index)) + '<a href="' + esc(m[2]) + '" target="_blank" rel="noopener">' + esc(m[1]) + '</a>';
        letzter = m.index + m[0].length;
      }
      return raus + esc(text.slice(letzter));
    }

    function blase(rolle, text, klasse) {
      var d = document.createElement('div');
      d.className = 'fd-fr-blase fd-fr-blase--' + rolle + (klasse ? ' ' + klasse : '');
      // Kunde: textContent (kein HTML, auch keine Links -- eigene Eingabe).
      // Bot: nur der eine Linktyp oben wird zu <a>, alles andere bleibt Text.
      if (rolle === 'bot') d.innerHTML = botHtml(text);
      else d.textContent = text;
      verlaufEl.appendChild(d);
      verlaufEl.scrollTop = verlaufEl.scrollHeight;
      return d;
    }

    function produktkarten(produkte) {
      if (!produkte || !produkte.length) return;
      var wrap = document.createElement('div');
      wrap.className = 'fd-fr-karten';
      produkte.forEach(function (p) {
        var z = zerlegeName(p.titel);
        var a = document.createElement('a');
        a.className = 'fd-fr-karte';
        a.href = (T.root || '/') .replace(/\/?$/, '/') + 'products/' + p.handle;
        a.innerHTML =
          '<span class="fd-fr-karte__bild"' + (p.bild ? ' style="background-image:url(' + cssUrl(p.bild) + ')"' : '') + '></span>' +
          '<span class="fd-fr-karte__tx">' +
            (z.nummer ? '<small>' + esc(z.nummer) + '</small>' : '') +
            '<b>' + esc(z.name) + '</b>' +
            (p.preis != null ? '<em>' + esc(p.preis) + ' ' + esc(p.waehrung || '') + '</em>' : '') +
          '</span>' +
          '<span class="fd-fr-karte__cta">' + esc(T.viewProduct) + '</span>';
        wrap.appendChild(a);
      });
      verlaufEl.appendChild(wrap);
      verlaufEl.scrollTop = verlaufEl.scrollHeight;
    }

    // Kappung wie serverseitig (16), sonst waechst sessionStorage unbegrenzt.
    function verlaufSpeichern() { speicherSchreiben(VERLAUF_KEY, JSON.stringify(verlauf.slice(-16))); }

    // Seitenwechsel ueberlebt: Blasen aus dem wiederhergestellten Verlauf
    // sofort ins (noch verborgene) Panel rendern, ueber dieselben Funktionen.
    var badge = wurzel.querySelector('[data-fr-badge]');
    verlauf.forEach(function (m) { blase(m.rolle, m.text); if (m.produkte) produktkarten(m.produkte); });
    if (badge) badge.hidden = verlauf.length === 0;

    // Idle-Choreografie der geschlossenen Figur: ueberwiegend gruss, alle
    // 8-20s EINE kurze Abweichung (eine Sequenz aus Pose+Dauer-Schritten),
    // danach zurueck zu gruss. Der naechste Zyklus wartet erst NACH der
    // Abweichung wieder 8-20s -- zwei Abweichungen liegen so nie naeher als
    // die kuerzeste Sequenzdauer (>6s Mindestabstand ist damit automatisch
    // erfuellt). Bricht sofort ab, sobald offen (jeder Schritt prueft neu).
    var IDLE_SEQUENZEN = [
      [['blinzelt', 400]],
      [['zuhoert', 2500]],
      [['denkt', 2500]],
      [['blick-links', 3000]],
      [['blick-rechts', 3000]],
      [['blick-links', 1500], ['gruss', 500], ['blick-rechts', 1500]], // "schaut sich um"
    ];
    // blick-links/blick-rechts/blinzelt kommen noch vom Avatar-Agenten -- eine
    // Sequenz spielt nur mit, wenn JEDES ihrer Bilder tatsaechlich laden
    // konnte (einmaliger onload/onerror-Test je Pose beim Init).
    var poseGeladen = {};
    Object.keys(T.poses || {}).forEach(function (name) {
      poseGeladen[name] = false;
      var test = new Image();
      test.onload = function () { poseGeladen[name] = true; };
      test.src = T.poses[name];
    });
    var idleTimer = null;
    function idleSchritt(seq, i) {
      if (offen || i >= seq.length) { if (!offen) pose('gruss'); return; }
      pose(seq[i][0]);
      idleTimer = setTimeout(function () { idleSchritt(seq, i + 1); }, seq[i][1]);
    }
    function idleZyklus() {
      idleTimer = setTimeout(function () {
        var pool = IDLE_SEQUENZEN.filter(function (seq) {
          return seq.every(function (schritt) { return poseGeladen[schritt[0]]; });
        });
        if (pool.length) idleSchritt(pool[Math.floor(Math.random() * pool.length)], 0);
        idleZyklus();
      }, 8000 + Math.random() * 12000);
    }
    function idleStop() { if (idleTimer) { clearTimeout(idleTimer); idleTimer = null; } }
    // Reduced motion: keine Idle-Wechsel, Figur bleibt in ihrer Ruhepose (gruss).
    if (!keinBewegen) idleZyklus();

    // Touch hat kein Hover: die Sprechblase einmalig nach 6s zeigen, wenn
    // noch nie geklickt wurde -- Flag ueberlebt die Sitzung, nicht mehr danach.
    var hinweis = wurzel.querySelector('[data-fr-hinweis]');
    var keinHover = window.matchMedia && window.matchMedia('(hover: none)').matches;
    var HINWEIS_KEY = 'fd-fr-hinweis-gezeigt';
    if (keinHover && hinweis && !speicherLesen(HINWEIS_KEY)) {
      setTimeout(function () {
        if (offen) return;
        speicherSchreiben(HINWEIS_KEY, '1');
        hinweis.classList.add('ist-sichtbar');
        setTimeout(function () { hinweis.classList.remove('ist-sichtbar'); }, 4000);
      }, 6000);
    }

    // Body-Scroll sperren, nur mobil (Vollbild-Panel deckt die Seite ab,
    // Desktop-Panel schwebt nur klein und braucht das nicht). iOS-sicheres
    // Muster: position:fixed + gemerkter Scroll-Stand statt blossem
    // overflow:hidden (das reicht auf Safari nicht, Seite scrollt trotzdem).
    var GESPERRT = 'fd-fr-body-gesperrt';
    var gemerkterScroll = 0;
    function bodySperren() {
      if (window.innerWidth >= 750) return;
      gemerkterScroll = window.scrollY;
      document.body.style.top = -gemerkterScroll + 'px';
      document.body.classList.add(GESPERRT);
    }
    function bodyEntsperren() {
      if (!document.body.classList.contains(GESPERRT)) return;
      document.body.classList.remove(GESPERRT);
      document.body.style.top = '';
      window.scrollTo(0, gemerkterScroll);
    }

    function oeffnen() {
      offen = true;
      idleStop(); // sauber aufraeumen -- keine Idle-Pose soll ins Gespraech platzen
      wurzel.classList.add('fd-fr--offen'); // CSS: Figur zieht auf Desktop neben das Panel, mobil weg
      bodySperren();
      panel.hidden = false;
      knopf.setAttribute('aria-expanded', 'true');
      if (badge) badge.hidden = true;
      if (!geoeffnetSchon) { geoeffnetSchon = true; blase('bot', T.greeting); pose('gruss'); }
      // Touch: nicht auto-fokussieren -- iOS klappt sonst sofort die Tastatur
      // auf und zoomt hinein, bevor der Kunde ueberhaupt hingesehen hat.
      if (!keinHover) input.focus();
      document.addEventListener('keydown', aufTastatur, true);
    }
    function schliessenFn() {
      offen = false;
      wurzel.classList.remove('fd-fr--offen');
      bodyEntsperren();
      panel.hidden = true;
      knopf.setAttribute('aria-expanded', 'false');
      document.removeEventListener('keydown', aufTastatur, true);
      knopf.focus();
      if (!keinBewegen) idleZyklus(); // Idle-Leben wieder aufnehmen
    }
    // Fokusfalle: Tab kreist innerhalb des Panels, ESC schliesst.
    function aufTastatur(e) {
      if (e.key === 'Escape') { e.preventDefault(); schliessenFn(); return; }
      if (e.key !== 'Tab') return;
      var fokussierbar = panel.querySelectorAll('button, textarea, a[href]');
      if (!fokussierbar.length) return;
      var erster = fokussierbar[0], letzter = fokussierbar[fokussierbar.length - 1];
      if (e.shiftKey && document.activeElement === erster) { e.preventDefault(); letzter.focus(); }
      else if (!e.shiftKey && document.activeElement === letzter) { e.preventDefault(); erster.focus(); }
    }

    knopf.addEventListener('click', function () { offen ? schliessenFn() : oeffnen(); });
    schliessen.addEventListener('click', schliessenFn);
    input.addEventListener('focus', function () { if (!laeuft) pose('zuhoert'); });
    // Enter sendet, Shift+Enter bricht die Zeile -- <textarea> submitted sonst nie von selbst.
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); form.requestSubmit(); }
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (laeuft || beendet) return;
      var text = input.value.trim().slice(0, 600);
      if (!text) return;
      input.value = '';
      verlauf.push({ rolle: 'kunde', text: text });
      verlaufSpeichern();
      blase('kunde', text);
      laeuft = true;
      senden.disabled = true; // kein Doppelsenden, bis die Antwort da ist
      // Danke/Freude ist ein echtes Signal aus der Nachricht, kein Timer.
      pose(/danke|merci|grazie|thanks|thank you/i.test(text) ? 'freut' : 'denkt');
      var denkblase = blase('bot', T.thinking, 'fd-fr-blase--denkt');

      var url = T.endpoint + '?locale=' + encodeURIComponent(T.locale || 'de');
      fetch(url, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        // host: fuer die markt-richtige Duftzwillinge-PDF (Waehrung/Sprache),
        // NICHT sicherheitsrelevant -- der Server nutzt es nur als Auswahl
        // zwischen vier eigenen PDFs, siehe pdfMarktVonHost() im Backend.
        body: JSON.stringify({ verlauf: verlauf, sitzung: sitzung, host: location.host }),
      }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          denkblase.remove();
          if (!res.ok || !res.d || !res.d.text) { blase('bot', T.errorGeneric); pose('gruss'); return; }
          verlauf.push({ rolle: 'bot', text: res.d.text, produkte: res.d.produkte, pose: res.d.pose });
          verlaufSpeichern();
          blase('bot', res.d.text);
          produktkarten(res.d.produkte);
          if (res.d.ende) { beendet = true; input.disabled = true; speicherLoeschen(VERLAUF_KEY); }
          pose(res.d.pose || 'gruss');
        })
        .catch(function () { denkblase.remove(); blase('bot', T.errorGeneric); pose('gruss'); })
        .then(function () { laeuft = false; senden.disabled = beendet; });
    });
  });
})();
